import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class MapsAddStuffService {

  API_URL: string = '';
  environmentName: string = '';

  //Property
  addPropertyFlowActiveSource = new BehaviorSubject<boolean>(false);
  addPropertyFlowActiveStream = this.addPropertyFlowActiveSource.asObservable();

  //Retailer
  addRetailerFlowActiveSource = new BehaviorSubject<boolean>(false);
  addRetailerFlowActiveStream = this.addRetailerFlowActiveSource.asObservable();

  //Pin
  addPinFlowActiveSource = new BehaviorSubject<boolean>(false);
  addPinFlowActiveStream = this.addPinFlowActiveSource.asObservable();

  constructor(public httpClient: HttpClient, public route: ActivatedRoute) { }

  focusFirstEmptyElement(elementClass) {
    let inputVal : any = <HTMLElement><any> document.getElementsByClassName(elementClass);
    if(inputVal) {
      for (let i = 0; i < inputVal.length; i++) {
        if(!inputVal[i].value || inputVal.length === 1) {
          inputVal[i].focus();
          return false;
        }
      }
    }
  }

  //Pin
  addPin(mapPin) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(
      this.API_URL + '/map-pin',
      JSON.stringify(mapPin),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  editPin(mapPin, pinId) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(
      this.API_URL + '/map-pin/' + pinId,
      JSON.stringify(mapPin),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  deletePin(pinId) {
    return this.httpClient.delete( this.API_URL + '/map-pin/'+pinId)
    .map( (res) => {
      return res;
    });
  }

  //Retailer
  getRetailerWithName(name) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer?'+
        'name='+encodeURIComponent(name))
    .map((res) => {
      return res;
    });
  }

  getRetailerData(within) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer/location?'+
      'within='+encodeURIComponent(JSON.stringify(within))
      )
    .map((res) => {
      return res;
    });
  }

  getSingleRetailerDetail(marker) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer/location/'+ marker.locationId +
      (marker.globalId ? '?globalId='+ marker.globalId : '')
      )
    .map((res) => {
      return res;
    });
  }

  constructRetailerObject(data) {
    let retailerObject:any = {
      name: data.name,
      spaceNumber: data.spaceNumber,
      featured: data.featured,
      squareFeet: data.squareFeet,
      retailerId: data.retailerId,
      globalId: data.globalId,
      geom: (<any>window).getPointGeoJson(this.checkIfGeomtObjectIsLatLngInstance(data.geom))
    };
    if((data.applyToCapsuleRecord !== undefined || data.applyToCapsuleRecord !== null) && (data.approvedForPublicView !== undefined || data.approvedForPublicView !== null)) {
      retailerObject.applyToCapsuleRecord = data.applyToCapsuleRecord;
      retailerObject.approvedForPublicView = data.approvedForPublicView;
    }
    return retailerObject;
  }

  checkIfGeomtObjectIsLatLngInstance(object) {
    if (!(object instanceof (<any>window).google.maps.LatLng)) {
      object = new (<any>window).google.maps.LatLng(object.lat, object.lng);
      return object;
    } else {
      return object;
    }
  }


  addRetailer(data) {
    let w = (<any>window),
    apiUrl = this.API_URL + '/rdx/retailer/location';
    apiUrl = data && data.skipSync ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'skipSync', 'true') : apiUrl;
    apiUrl = w.mmap.isOrganizationEditAdmin() ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'applyToCapsuleRecord', 'true') : apiUrl;
    apiUrl = w.mmap.adminMode ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'inhibitFork', 'true') : apiUrl;
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(apiUrl,
        JSON.stringify(this.constructRetailerObject(data)),
        { headers }
      )
      .map((res) => {
        return res;
      });
  }

  editRetailer(data) {
    let w = (<any>window),
    apiUrl = this.API_URL + '/rdx/retailer/location/' + data.locationId;
    apiUrl = data && data.skipSync ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'skipSync', 'true') : apiUrl;
    apiUrl = w.mmap.isOrganizationEditAdmin() ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'applyToCapsuleRecord', 'true') : apiUrl;
    apiUrl = (w.mmap.adminMode || data.inhibitFork) ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'inhibitFork', 'true') : apiUrl;
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(apiUrl,
        JSON.stringify(this.constructRetailerObject(data)),
        { headers }
      )
      .map((res) => {
        return res;
      });
  }

  deleteRetailer(locationId, profileId) {
    return this.httpClient.delete(
      this.API_URL + '/rdx/retailer/location/'+locationId+'?profileId='+(profileId ? profileId : '0')+
      ((<any>window).mmap.isOrganizationEditAdmin() ? '&applyToCapsuleRecord=true' : '')
    )
      .map( (res) => {
        return res;
      });
  }

  //Property
  constructPropertyObject(data) {
    let propertyObject:any = {
      name: data.name,
      inhibitFork: data.inhibitFork,
      addressText: data.addressText,
      description: data.description,
      grossLeasableArea: data.grossLeasableArea ? parseFloat(data.grossLeasableArea.replace(/\,/g,'')) : null,
      geom: data.polygon ? (<any>window).getPolygonGeoJson(data.polygon) : (<any>window).getPointGeoJson(data.position),
      globalId: data.globalId,
      retailerLocations: data.retailerLocations
    };
    if((data.applyToCapsuleRecord !== undefined || data.applyToCapsuleRecord !== null) && (data.approvedForPublicView !== undefined || data.approvedForPublicView !== null)) {
      propertyObject.applyToCapsuleRecord = data.applyToCapsuleRecord;
      propertyObject.active = data.approvedForPublicView;
    }
    return propertyObject;
  }

  addProperty(data) {
    let w = (<any>window),
    apiUrl = this.API_URL + '/rdx/property';
    apiUrl = w.mmap.isOrganizationEditAdmin() ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'applyToCapsuleRecord', 'true') : apiUrl;
    apiUrl = (w.mmap.adminMode || data.inhibitFork) ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'inhibitFork', 'true') : apiUrl;
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(apiUrl,
      JSON.stringify(this.constructPropertyObject(data)),
      { headers }
    )
    .map((res) => {
      w.apiPolling.apiPropertyCall(res);
      return res;
    });
  }

  getSinglePropertyDetails(propertyId, globalId) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/property/'+propertyId+(globalId? '?globalId='+globalId:''))
    .map((res) => {
      return res;
    });
  }

  updateProperty(property) {
    let w = (<any>window),
    apiUrl = this.API_URL + '/rdx/property/'+property.id;
    apiUrl = property.globalId ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'globalId', property.globalId) : apiUrl;
    apiUrl = w.mmap.isOrganizationEditAdmin() ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'applyToCapsuleRecord', 'true') : apiUrl;
    apiUrl = (w.mmap.adminMode || property.inhibitFork) ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'inhibitFork', 'true') : apiUrl;
    apiUrl = !(w.isApplicationTourbooks() && (w.userData && w.userData.organizationType === 'FREE')) ? w.apiUrlFormatter.addQueryParamToUrl(apiUrl, 'profileId', (property.ownerId ? property.ownerId : property.ownerProfileId ? property.ownerProfileId : (property.details && property.details.ownerProfileId) ? property.details.ownerProfileId : '0')) : apiUrl;
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(apiUrl,
      JSON.stringify(this.constructPropertyObject(property)),
      { headers }
    )
    .map((res) => {
      w.apiPolling.apiPropertyCall(res);
      return res;
    });
  }

  deleteProperty(propertyId, globalId) {
    return this.httpClient.delete(
      this.API_URL + '/rdx/property/'+propertyId+(globalId? '?globalId='+globalId:'')+
      ((<any>window).mmap.isOrganizationEditAdmin() ? (globalId?'&':'?') + 'applyToCapsuleRecord=true' : '')
    )
    .map((res) => {
      return res;
    });
  }

  trimSpacesBeforeAndAfterString(input) {
    return input && input.replace(/^\s+|\s+$/gm,'');
  }

  isOrganizationTypeFree() {
    let w = (<any>window);
    return w.userData && w.userData.organizationType === 'FREE';
  }

  updateTenantLogo(tenantId, data) {
    if(data) {
      let file:File = data,
      formData:FormData = new FormData();
      formData.append('file', file, file.name);

      const headers = { 'Accept': 'application/json' };

      return this.httpClient.post(
        this.API_URL + '/rdx/tenant/'+ tenantId +'/logo',
        formData,
        { headers }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/maps-add-stuff.service.ts